(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fairs-coming-soon"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCountdown(cd) {
    if (!cd || cd.__countdownInit) return;
    cd.__countdownInit = true;

    var targetRaw = cd.getAttribute('data-target');
    if (!targetRaw) return;

    // Accepts: "YYYY-MM-DD HH:MM" or ISO. Local time.
    var target = new Date(targetRaw.replace(' ', 'T'));
    if (isNaN(target.getTime())) return;

    var elDays = cd.querySelector('[data-days]');
    var elHours = cd.querySelector('[data-hours]');
    var elMins = cd.querySelector('[data-minutes]');
    var elSecs = cd.querySelector('[data-seconds]');

    function pad2(n){ return String(n).padStart(2, '0'); }

    function tick(){
      var now = new Date();
      var diffMs = target.getTime() - now.getTime();

      if (diffMs <= 0){
        if (elDays) elDays.textContent = "0";
        if (elHours) elHours.textContent = "00";
        if (elMins) elMins.textContent = "00";
        if (elSecs) elSecs.textContent = "00";
        return;
      }

      var totalSeconds = Math.floor(diffMs / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;

      if (elDays) elDays.textContent = String(days);
      if (elHours) elHours.textContent = pad2(hours);
      if (elMins) elMins.textContent = pad2(mins);
      if (elSecs) elSecs.textContent = pad2(secs);
    }

    tick();
    cd.__timer = setInterval(tick, 1000);
  }

  function runAll() {
    document.querySelectorAll('[data-countdown]').forEach(initCountdown);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  // Shopify theme editor / dynamic section reload support
  document.addEventListener('shopify:section:load', runAll);
})();

  } catch(e) { console.error(e); }
})();
})();
